// Vue CLI embeds this public setting at startup/build time.
export const AppRuntimeMode = process.env.VUE_APP_AppRuntimeMode;

export function isAgentSandbox(runtimeMode = AppRuntimeMode,
    hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
    return runtimeMode === 'AgentSandbox' &&
        ['localhost', '127.0.0.1', '::1', '[::1]'].includes(hostname);
}

export function isSignalREnabled(runtimeMode = AppRuntimeMode,
    hostname = typeof window === 'undefined' ? '' : window.location.hostname,
    functionServer = process.env.VUE_APP_AzureFunctionsServer) {
    if (!isAgentSandbox(runtimeMode, hostname)) return true;
    try {
        const endpoint = new URL(functionServer);
        return endpoint.protocol === 'https:' && endpoint.hostname === 'localhost' &&
            endpoint.port === '44303' && endpoint.pathname === '/' &&
            !endpoint.username && !endpoint.password && !endpoint.search && !endpoint.hash;
    } catch (_) {
        return false;
    }
}

// Use only at the named CS local-service consumers, not as a global -4 policy.
export function isLocalServiceUnavailable(returnCode, runtimeMode = AppRuntimeMode,
    hostname = typeof window === 'undefined' ? '' : window.location.hostname) {
    return returnCode === -4 && isAgentSandbox(runtimeMode, hostname);
}
